import React,{Component } from 'react';
import mwlogo from './group_logo.png';
import zlogo from './z-technics-logo.png';
import moment from 'moment';
class Login extends Component {
	
	 constructor(props) {
    super(props);		
    this.loginHandle = this.loginHandle.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.state = {
		loginError : '',
		readOnlyView : false,
		shipment : { dimensions : [], comments : [],filesnames:[] },
		token : null
    }
    
//check if logedIn
	if (!props.value) {
	fetch("https://demo-rcm.mauriceward.com/api.php?action=checkIfLoged" , {   
		method: 'GET',
		credentials: 'include'
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
        	if (res.status==="error") {
				this.setState({ loginError : res.message	})
			    if(window.location.hash.indexOf("#")!==-1){
			    	var q = window.location.hash.split("&");
			    	if(Number.isInteger(Number(q[0].substr(1)))&&q[1].length>30){
							window.location.hash="";
							fetch("https://demo-rcm.mauriceward.com/api.php?readonly&recnum="+q[0].substr(1)+"&token="+ q[1] )
								 .then((response) => response.json())
								 .then(
						        (res) => {
						        	if (res.status==="error") {
										this.setState({ loginError : res.message	})
									}
									else {
										var item = res;
										if(item.dimensions!==null)item.dimensions = JSON.parse(item.dimensions);
										if(item.comments!==null)item.comments = JSON.parse(item.comments);
										item.filesnames = JSON.parse(item.filesnames);
						        		if(item.booking_date!==null)item.booking_date=moment.utc(item.booking_date).format("DD.MM.YYYY");
						        		if(item.ready_date!==null)item.ready_date=moment.utc(item.ready_date).format("DD.MM.YYYY");
						        		if(item.est_pickup!==null)item.est_pickup=moment.utc(item.est_pickup).format("DD.MM.YYYY");
						        		if(item.actual_pickup!==null)item.actual_pickup=moment.utc(item.actual_pickup).format("DD.MM.YYYY");
						        		if(item.eta!==null)item.eta=moment.utc(item.eta).format("DD.MM.YYYY");
						        		if(item.actual_arrival!==null)item.actual_arrival=moment.utc(item.actual_arrival).format("DD.MM.YYYY");
						        		if(item.loaded_date!==null)item.loaded_date=moment.utc(item.loaded_date).format("DD.MM.YYYY");
						        		if(item.off_loaded!==null)item.off_loaded=moment.utc(item.off_loaded).format("DD.MM.YYYY");
										this.setState({ readOnlyView :true, shipment : { ...this.state.shipment,...res,token:q[1] }});
								//		this.setState({ userLoged:true });
									}
						        }),
						         (error) => {
						         	alert(error)
						          this.setState({
						            isLoaded: true,
						            error
						          });
						        }
					}
			    }  
			}
			if (res.status==="success") {
				this.props.onLoginSuccess(res);
				this.setState({ userLoged:true });
			}
        }),
         (error) => {
         	alert(error)
          this.setState({
            isLoaded: true,
            error
          });
        } 	
    
 	}
 }
 downloadFile(num){
	window.open("https://demo-rcm.mauriceward.com/api.php?downloadFileAnonymn="+num+"&recnum="+this.state.shipment.recnum+"&token="+this.state.shipment.token+"&stamp"+new Date().toUTCString() );
}
 loginHandle(e){
 	e.preventDefault();
	fetch("https://demo-rcm.mauriceward.com/api.php?action=login" , {   
		method: 'POST',
		credentials: 'include',
		body : JSON.stringify({"username":encodeURI(e.target.username.value),"password": encodeURI(e.target.password.value)})
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
        	if (res.status==="error") {
				this.setState({ loginError : res.message	})
			}
			if (res.status==="success") {
				this.props.onLoginSuccess(res);
		//		this.setState({ userLoged:true });
			}
        }),
         (error) => {
         	alert(error)
          this.setState({
            isLoaded: true,
            error
          });
        } 
 }

	render(){	
    if(this.state.readOnlyView===false)return (
<div className="container-fluid">
        <form className="form-horizontal" onSubmit={ this.loginHandle }>
            <div className="row mt-2">
                <div className="col-md-4"></div>
                <div className="col-md-4 text-center">
                <a href="https://www.mauriceward.com"><img src={mwlogo} className="mwlogo"/></a>
                    <h2>Please Login</h2>
                    <hr/>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-4">
                    <div className="form-group has-danger">
                        <label className="sr-only" for="email">Username</label>
                        <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                            <div className="input-group-addon" style={{width: 2.6+"rem"}}><i className="fa fa-user"></i></div>
                            <input type="text" name="username" className="form-control" id="email"
                                   placeholder="Username" required autofocus autocomplete="off" />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-control-feedback">
                        <span className="text-danger align-middle">
                           { this.state.loginError }
                        </span>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-4">
                    <div className="form-group">
                        <label className="sr-only" for="password">Password</label>
                        <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                            <div className="input-group-addon" style={{width: 2.6+"rem"}}><i className="fa fa-key"></i></div>
                            <input type="password" name="password" className="form-control" id="password"
                                   placeholder="Password" required/>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-control-feedback">
                        <span className="text-danger align-middle">
                           
                        </span>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="d-flex justify-content-center">
                        <span className="alert alert-primary justify-content-center">
                           Username : demo<br/>
                           Password : demo
                        </span>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-center" style={{paddingTop: 1+"rem"}}>
                    <button type="submit" className="btn btn-success col-sm-6 col-md-2 " ><i className="fa fa-sign-in"></i> Login</button>
                </div>
        </form>
        <footer className="text-center mt-5 zlogo"><p className="text-muted">Powered by</p><a href="https://www.z-technics.com/en"><img src={zlogo}/></a>
        </footer>
    </div>
    );
    if(this.state.readOnlyView===true){
 const dimensionRows = this.state.shipment.dimensions.map((item)=>
<div className="form-group inline-inputs row">
		<div className="col-5 col-md-1">
			<input className="form-control" name="packing" data-submit="exclude" type="hidden"/>
			<span className="form-control" name="packing">{item.packing}</span>
		</div>
		<div className="col-6 col-md-2">
			<div className="input-group">
				<input className="form-control" type="number" min="0" name="length" value={item.length} onChange={ (e)=> this.updateDimensionRow(e,item.rowId) } placeholder='Length'/>
				<div className="input-group-append">
					<span className="input-group-text">cm</span>
				</div>
			</div>
		</div>
		<div className="col-6 col-md-2">
			<div className="input-group">
				<input className="form-control" type="number" min="0" name="width" value={item.width} onChange={ (e)=> this.updateDimensionRow(e,item.rowId) } placeholder='Width'/>
				<div className="input-group-append">
					<span className="input-group-text">cm</span>
				</div>
			</div>
		</div>
		<div className="col-6 col-md-2">
			<div className="input-group">
				<input className="form-control" type="number" min="0" name="height" value={item.height} onChange={ (e)=> this.updateDimensionRow(e,item.rowId) } placeholder='Height'/>
				<div className="input-group-append">
					<span className="input-group-text">cm</span>
				</div>
			</div>
		</div>
		<div className="col-6 col-md-2">
			<div className="input-group">
				<input className="form-control" type="number" min="0" name="pieces" value={item.pieces} onChange={ (e)=> this.updateDimensionRow(e,item.rowId) } placeholder='Number of pieces'/>
				<div className="input-group-append">
					<span className="input-group-text">pcs</span>
				</div>
			</div>
		</div>
		<div className="col-6 col-md-2">
			<div className="input-group">
				<input className="form-control" type="text" min="0" name="weight" value={item.weight} onChange={ (e)=> this.updateDimensionRow(e,item.rowId) } placeholder='Weight per piece'/>
				<div className="input-group-append">
					<span className="input-group-text">kg</span>
				</div>
			</div>
		</div>
</div>
);    	
var previous_comments = [];
if (this.state.shipment.comments!==null) {
	previous_comments = this.state.shipment.comments.map((item)=>{
	var data = JSON.parse(item);
	data.date = moment(data.date).format("DD.MM.YYYY");
	return <li className="list-group-item">{data.date} : { data.text }</li>
});
}
    	return(
     <div className="container-fluid">
 					<div className="col-12 mt-2">    	
	 	 		    	<button className="btn btn-primary" type="button" onClick={()=>this.setState({ readOnlyView:false })}><i className="fa fa-undo"/> Back</button>
	 	 		    </div>
	   				<div className="form-group ">
	   					<div className="control-label col-3" >Region</div>
	   					<div className="col-12 col-md-6 col-lg-3">
								<select className="form-control" name="region" value={ this.state.shipment.region } onChange = { (e)=> this.shipmentHandleChange(e) }>
									<option value="">Choose region</option>
									<option value="EU Collection">EU Collection</option>
									<option value="Non EU Collection">Non EU Collection</option>
									<option value="Domestic Collection">Domestic Collection</option>
								</select>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-12 col-md-3">BOL Number</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<input type="text" className="form-control" value={ this.state.shipment.po_num } name="po_num" onChange= { (e)=> this.shipmentHandleChange(e) }></input>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-3">Asset Number</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<input type="text" className="form-control" value={ this.state.shipment.nl_ref } name="nl_ref" onChange= { (e)=> this.shipmentHandleChange(e) } ></input>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-3">MW Reference</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<input type="text" className="form-control" value={ this.state.shipment.cts_ref } name="cts_ref" onChange= { (e)=> this.shipmentHandleChange(e) } ></input>
	   					</div>
	   				</div>
						<div className="form-group">
							<label className="control-label col-3">Packing</label>
						</div>
							{ dimensionRows }
	   				<div className="form-group">
	   					<div className="control-label col-6 col-md-3">Total Weight</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<input type="text" className="form-control" value={ this.state.shipment.total_weight } readOnly></input>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-6 col-md-3">Goods description</div>
	   					<div className="col-12 col-md-9">
	   						<textarea type="text" className="form-control" name="goods_description" value={ this.state.shipment.goods_description } onChange = { (e)=> this.shipmentHandleChange(e)}></textarea>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-3">Pieces</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<input type="text" className="form-control" value={ this.state.shipment.pieces } readOnly></input>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-12 col-md-3">DG / Non DG</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<select className="form-control" name="danger_goods" value={ this.state.shipment.danger_goods } onChange = { (e)=> this.shipmentHandleChange(e) }>
	   							<option value="">Please select</option>
	   							<option value="dg">DG</option>
	   							<option value="nondg">Non DG</option>
	   						</select>
	   					</div>
	   				</div>
	   				<div className="row col-12">
		   				<div className="form-group col-12 col-md-4 col-lg-3">
		   					<div className="control-label">Booking date</div>
		   					<div className="">
									<input className="form-control" type="text" value={this.state.shipment.booking_date} />
		   					</div>
		   				</div>
		   				<div className="form-group col-12 col-md-4 col-lg-3">
		   					<div className="control-label">Ready date</div>
		   					<div className="">
								<input className="form-control" type="text" value= { this.state.shipment.ready_date }/> 
		   					</div>
		   				</div>
		   				<div className="form-group col-12 col-md-4 col-lg-3 ">
		   					<div className="control-label">Est pick up date</div>
		   					<div className="">
								<input className="form-control" type="text" value={ this.state.shipment.est_pickup } /> 
		   					</div>
		   				</div>
		   				<div className="form-group col-12 col-md-4 col-lg-3 ">
		   					<div className="control-label">Actual pick up date</div>
		   					<div className="">
								<input className="form-control" type="text" value= { this.state.shipment.actual_pickup } /> 
		   					</div>
		   				</div>
		   				<div className="form-group col-12 col-md-4 col-lg-3 ">
		   					<div className="control-label">ETA</div>
		   					<div className="">
								<input className="form-control" type="text" value={ this.state.shipment.eta }/> 
		   					</div>
		   				</div>
		   				<div className="form-group col-12 col-md-4 col-lg-3 ">
		   					<div className="control-label">Actual arrival</div>
		   					<div className="">
								<input className="form-control" type="text" value={ this.state.shipment.actual_arrival }/> 
		   					</div>
		   				</div>
		   				<div className="form-group col-12 col-md-4 col-lg-3 ">
		   					<div className="control-label">Loaded on trailer</div>
		   					<div className="">
								<input className="form-control" type="text" value={ this.state.shipment.loaded_date }/> 
		   					</div>
		   				</div>
							<div className="form-group col-12 col-md-4 col-lg-3 ">
		   					<div className="control-label">Off loaded</div>
		   					<div className="">
								<input className="form-control" type="text" value= { this.state.shipment.off_loaded }/> 
		   					</div>
		   				</div>
	   				</div>
	   				<div className="form-group ">
	   					<div className="control-label col-12 col-lg-3">Previous comments</div>
	   					<div className="col-12 col-lg-9">
	   						<ul className="list-group">
		   						{ previous_comments }
		   					</ul>
	   					</div>
	   				</div>
	   				<div className="col-12 col-lg-9 mt-1">
	   					<div className="card">
		   					<h5 className="card-header">
		   					Pickup
		   					</h5>
		   					<div className="card-body">
				   				<div className="form-group">
				   					<div className="control-label col-3" id="supplier">Supplier</div>
				   					<div className="col-12">
				   						<div className="row">
				   						<div className="col-8 col-lg-10">
				   						<input type="text" className="form-control" name="supplier_name" value={ this.state.shipment.supplier_name } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   					</div>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Pickup Address</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="Street" name="pickup_street" value={ this.state.shipment.pickup_street } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="City" name="pickup_city" value={ this.state.shipment.pickup_city } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="Country" maxLength="100" name="pickup_country" value={ this.state.shipment.pickup_country } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="Post code" maxLength="15" name="pickup_zip" value={ this.state.shipment.pickup_zip } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Contact Person</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="Name, tel, email" name="pickup_contact" value={ this.state.shipment.pickup_contact } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Opening hours</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="" name="pickup_opening_hours" value={ this.state.shipment.pickup_opening_hours } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
			   				</div>
	   					</div>	   				
	   				</div>
	   				<div className="col-12 col-lg-9 mt-1 mb-1">
	   					<div className="card">
		   					<h5 className="card-header">
		   					Delivery
		   					</h5>
		   					<div className="card-body">
				   				<div className="form-group">
				   					<div className="control-label col-3" id="consignee">Consignee</div>
				   					<div className="col-12">
				   						<div className="row">
				   						<div className="col-8 col-lg-10">
				   						<input type="text" className="form-control" name="consignee_name" value={ this.state.shipment.consignee_name } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   						</div>
				   						</div>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Ship to Address</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="Street" name="delivery_street" value={ this.state.shipment.delivery_street } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="City" name="delivery_city" value={ this.state.shipment.delivery_city } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="Country" maxLength="100" name="delivery_country" value={ this.state.shipment.delivery_country } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="Post code" maxLength="15" name="delivery_zip" value={ this.state.shipment.delivery_zip } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Contact person</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="Name, tel, email" name="delivery_contact" value={ this.state.shipment.delivery_contact } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Opening hours</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="" name="delivery_opening_hours" value={ this.state.shipment.delivery_opening_hours } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
			   				</div>
		   				</div>
		   			</div>
	   				<div className="form-group">
	   					<div className="control-label col-12 col-md-3">Special instructions</div>
	   					<div className="col-12 col-lg-9">
								<textarea className="form-control" name="special_instructions" value={ this.state.shipment.special_instructions } onChange = { (e)=> this.shipmentHandleChange(e) }/>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-12 col-md-3">Send email alerts to</div>
	   					<div className="col-12 col-lg-9">
	   						<input type="text" placeholder="email addresses separated by commas" className="form-control" value={ this.state.shipment.notice_emails } name="notice_emails" onChange= { (e)=> this.shipmentHandleChange(e) }></input>
	   					</div>
	   				</div>
	   				<div className={"form-group " + (this.state.isNewRecord ? 'd-none' : '') }>
	   					<div className="control-label col-3" >Status</div>
	   					<div className="col-12 col-lg-3">
								<span className="form-control">{ this.state.shipment.status }</span>
	   					</div>
	   				</div>
	   				<div className="form-group col-12 " >
	   					<div className="control-label">Attachments</div>
	   					<div className="col-12">
	   						<div className="row fileslist">
	   						{ this.state.shipment.filesnames.map((file)=>
									<div className="list-group-item col-12 col-sm-6 col-md-3"> <button type="button" className="btn btn-secondary" onClick={ ()=> this.downloadFile(file[0]) }><span className="fa fa-download"></span></button> { file[1] }</div>	   			
									)			
	   						 }
	   						 </div>				
	   					</div>
	   				</div>	   			
	   			</div>
    )
 	}
 }
};

export default Login;


// WEBPACK FOOTER //
// ./src/login.js